module.exports = __webpack_public_path__ + "static/media/email-new.f3ca8d6e.svg";